<template>
	<div class="page">
		<div class="top_box">
			<div class="top_line">智能生成头像昵称</div>
			<p>小火柴送你了你一个头像和昵称</p>
			<p>如不满意，后续可在个人中心修改~</p>
		</div>
		<img :src="avatar" />
		<div class="date_line">
			{{nickName}}
		</div>
		
		<div class="next_step_btn">
			<div  @click="nextStep" class="customStyle">完 成</div>
		</div>
		<div class="user-agreement">
			<span>
				注册完成即代表同意<label @click="goto_user_agreement()">《小火柴用户协议》</label>
			</span>
		</div>
	</div>
</template>

<script>
    import { mapMutations, mapActions } from "vuex";
	import * as tool from "../../api/common";
	export default{
		data(){
			return{
				nickName:'曾经的那些年',
				avatar:''
			}
		},
		mounted() {
			this.init();
		},
		methods:{
             ...mapMutations(["get", "post"]), //引入方法
             ...mapActions(["act_get_userinfo"]), //引入方法

			 init(){
				var uid = this.$store.state.uid;
            	var self = this;

				//获取用户基础信息：头像，昵称
				self.act_get_userinfo({
					uid: uid,
					success: function (u) {
						//console.log(JSON.stringify(u));
						self.nickName = u.nick;
						self.avatar = u.photo;
					},
				});

				//注册完成，记录登录信息
				self.get({
					url: '/App/Set_Login_on/?uid=' + uid,
					success: function (data) {
					console.log("后台完成登录记录");
					},
					error: function (err) {
					}
				});

			 },
			
			nextStep(){
				var sysdic = this.$store.state.sysdic;
                var data = {
					"from": sysdic.xhc_admin_uid,
					"type": "sys_guide_hello",
					"txt": "你好吖，欢迎来到小火柴",
					"dtm": new Date().Format("yyyy/MM/dd hh:mm:ss")
				}
				this.$store.dispatch('act_push_message', data);

				// window.location.href='/';
				// this.$router.replace({ name: "main", params: { from: 'reg_complate' } } );
                //this.$router.push({ name: "index"} );
				//新用户跳转，代理新用户引导关注公众号，其他新用户正常进入首页
				var fz_tag = this.$store.state.fz_tag;
				if (fz_tag !== "") {
					this.$router.push({ name: "reg_wxgz"} );
				} else {
					this.$router.replace({ name: "main", params: { from: 'reg_complate' } } );
				}
			},
			goto_user_agreement() {
				this.$router.push({ name: "user_agreement" } );
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		padding-top:5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		color:#333;
		font-size: 1rem;
		.top_box{
			width: 80%;
			.top_line{
				text-align: center;
				font-weight: bold;
				padding-bottom: 1rem;
			}
			.top_line:before,.top_line:after{
				content: " ";
				display: inline-block;
				width: .5rem;
				height:.5rem;
				border-radius: 50%;
				background: linear-gradient(to right, #af5ee8, #FFC3C4);
				margin:0 1rem 0 0;
				vertical-align: middle;
			}
			.top_line:after{
				margin:0 0 0 1rem;
			}
			p{
				font-size: .85rem;
				text-align: center;
				color: #666;
			}
		}
		img{
			margin-top: 2rem;
			width: 8rem;
			height: 8rem;
			border-radius: 50%;
			border: 1px solid #f0f0f0 !important;
		}
		.date_line{
			width: 60%;
			text-align: center;
			padding: 2rem 1rem .5rem;
			font-size: 1.2rem;
			border-bottom: 1px solid #DCDFE6;
		}
		.user-agreement {
			margin-top: 1rem;
			font-size: 0.75rem;
			span {
				color: #666;
			}
			label {
				color: #576B95;
			}
		}
		.next_step_btn{
			width: 70%;
			margin-top: 5rem;
            .customStyle{
					border:none;
					background: linear-gradient(to right, #af5ee8, #f5aebf);
					box-shadow:0px 0px 20px #ECECEC;
                    
                    height: 3rem;
                    line-height: 3rem;
                    border-radius: 2rem;
					color:#ffff;
                    text-align: center;
				}
		}
	}
</style>
